module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"user_display_name":"這是 <b>%{name}</b> 的評論。"}}')
  delete Component.options._Ctor
}
